import ViewItemListEvent from './ViewItemListEvent';
import { ItemFactory } from "../dto/item/ItemFactory";
import { getModePrice } from '../../utilities';
export default class PieceViewItemListNormalizer {
    normalize(elements, catalog) {
        const viewItemListEvent = new ViewItemListEvent();
        const gaDivs = $(elements).find('.ga');
        $(gaDivs).each(function (index, gaDiv) {
            const item = ItemFactory.createFromDataAttribute($(gaDiv));
            item.itemPricing = getModePrice();
            item.index = index + 1;
            viewItemListEvent.itemCollection.addItem(item);
        });
        viewItemListEvent.itemNumber = viewItemListEvent.itemCollection.length();
        viewItemListEvent.sortOutType = 'dispo_price';
        return viewItemListEvent;
    }
    support(element, catalog) {
        return 'pieces' === catalog;
    }
}
